import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromExternalManagement from './external-users-management.reducers';

export interface ExternalManagementState {
  stateData: fromExternalManagement.State;
}

export interface State extends fromRoot.AppState {
  externalManagement: ExternalManagementState;
}

export const reducers = {
  stateData: fromExternalManagement.reducer
};

export const selectExternalManagementState = createFeatureSelector<ExternalManagementState>('externalManagement');
export const selectExternalManagementStateData = createSelector(
  selectExternalManagementState,
  (state: ExternalManagementState) => state.stateData
);
export const getExternalManagementScreenErrorMessage = createSelector(
  selectExternalManagementStateData,
  fromExternalManagement.getError
);
export const getExternalManagementScreenPending = createSelector(
  selectExternalManagementStateData,
  fromExternalManagement.getPending
);
export const getExternalManagementState = createSelector(
  selectExternalManagementStateData,
  fromExternalManagement.getStateData
);
